import getApiCore from '../core'

const mfaPath = (userId: string) => `users/${userId}/mfa`

export default function getMfaApi(authToken: string) {
  const apiCore = getApiCore(authToken)
  return {
    getMfa: (userId: string) => apiCore.get(mfaPath(userId)),
    activateMfa: (userId: string) =>
      apiCore.put(mfaPath(userId), {
        data: {
          mfaOptIn: true,
        },
      }),
  }
}
